import { useQuery } from '@tanstack/react-query';
import { useManagedWorkspace } from './useManagedWorkspace';
import { apiRequest } from '@/lib/queryClient';


export interface WorkspaceRole {
  _id: string;
  name: string;
  displayName: string;
  description: string;
  isSystemRole: boolean;
  permissions: Record<string, Record<string, boolean>>;
}

export function useWorkspaceRoles() {
  const { managedWorkspace } = useManagedWorkspace();

  return useQuery<WorkspaceRole[]>({
    queryKey: ['workspace-roles', managedWorkspace?._id],
    queryFn: async () => apiRequest('GET', `/api/workspaces/${managedWorkspace?._id}/roles`) as Promise<WorkspaceRole[]>,
    enabled: !!managedWorkspace?._id,
  });
}
